import { render, staticRenderFns } from "./zxzjreplylist.vue?vue&type=template&id=b00f6202&scoped=true&"
import script from "./zxzjreplylist.vue?vue&type=script&lang=js&"
export * from "./zxzjreplylist.vue?vue&type=script&lang=js&"
import style0 from "./zxzjreplylist.vue?vue&type=style&index=0&id=b00f6202&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00f6202",
  null
  
)

export default component.exports